<ion-item class="question-item" [formGroup]="form">
  <ion-label position="stacked" *ngIf="label">{{ label }}</ion-label>
  <ion-textarea
    [formControlName]="inputName"
    autoGrow="true"
    [ngClass]="{ error: isError }"
    cols="3"
    [disabled]="disabled"
    spellcheck="true"
    autocorrect="on"
    autocapitalize="sentences"
  >
  </ion-textarea>
</ion-item>
